import { createContext, useContext } from 'react';

type SessionNameEditingContextValue = {
  setIsEditing: (isEditing: boolean) => void;
};

const SessionNameEditingContext = createContext<SessionNameEditingContextValue | null>(null);

export const SessionNameEditingProvider = SessionNameEditingContext.Provider;

export function useSessionNameEditingContext(): SessionNameEditingContextValue | null {
  return useContext(SessionNameEditingContext);
}

